import { createContext } from 'react';
let DisplayOptionsContext = createContext(null);
export default DisplayOptionsContext;